/**
 * Shared animation constants following Emil Kowalski's design engineering philosophy.
 * Import these instead of defining animation values inline.
 */

// Strong custom easing curves (never use default CSS easings)
export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1];
export const EASE_IN_OUT: [number, number, number, number] = [0.77, 0, 0.175, 1];
/** iOS-like drawer curve (Ionic). For panels that slide in from an edge. */
export const EASE_DRAWER: [number, number, number, number] = [0.32, 0.72, 0, 1];

// Duration constants (seconds for Framer Motion)
export const DURATION_FAST = 0.12;
export const DURATION_NORMAL = 0.2;
export const DURATION_SLOW = 0.3;

// Reusable animation presets
export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: DURATION_NORMAL, ease: EASE_OUT },
};

export const slideUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
  transition: { duration: 0.25, ease: EASE_OUT },
};

export const scaleIn = {
  initial: { opacity: 0, scale: 0.95 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.95 },
  transition: { duration: DURATION_NORMAL, ease: EASE_OUT },
};

// Stagger container variant factory
export const staggerContainer = (staggerDelay = 0.05) => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: staggerDelay },
  },
});

// Stagger child item variant
export const staggerItem = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.25, ease: EASE_OUT },
  },
};

// Slide from right (for panels/drawers)
export const slideFromRight = {
  initial: { x: '100%' },
  animate: { x: 0 },
  exit: { x: '100%' },
  transition: { duration: DURATION_SLOW, ease: EASE_OUT },
};
